import { render, staticRenderFns } from "./EmployeeSocialInsuranceRegistration.vue?vue&type=template&id=2252aabb&scoped=true&"
import script from "./EmployeeSocialInsuranceRegistration.vue?vue&type=script&lang=js&"
export * from "./EmployeeSocialInsuranceRegistration.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSocialInsuranceRegistration.vue?vue&type=style&index=0&id=2252aabb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252aabb",
  null
  
)

export default component.exports